import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";

import {loadingMessage} from "@Xpresso/loaders/loading-message";

import {Layout} from "../../../../layout/layout";

export const loadTemplateBack = ({templateId, next, fullPageLoading=true}) => cs(
    consumeContext("apis"),
    ["template", ({apis}, next) => Load2({
        fetch: () => apis.next.getTemplateBack(templateId),
        captureException: true,
        next,
    })],
    ({template}) => !fullPageLoading ? (
        template?.value ? (
            next(template.value)
        ) : (
            <div className="kit-option-step-h8f kit-option-step">
                <div className="content">
                    Loading...
                </div>
            </div>
        )
    ) : template.loading ? (
        <Layout className="customize-layout-95r" active={"product-options"}>
            <div className="kit-option-step-h8f kit-option-step">
                {loadingMessage({message:"Loading Template Back...",progress:60})}
            </div>
        </Layout>
    ) : (
        template.exception?.status === 403 ? (
            <Layout className="customize-layout-95r" active={"product-options"}>
                <div className="kit-option-step-h8f kit-option-step">
                    <div className="center">
                        You do not have access to this template.<br/>
                        Please select a different template or contact your administrator<br/>
                    </div>
                </div>
            </Layout>
        ) : (
            next(template.value)
        )
    ),
);
